<template>
  <div class="full-screen">
    <p>
      <md-icon>warning</md-icon>
    </p>
    <p>
      {{ message }}
    </p>
    <div class="footer">
      <gl-logo-app />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    message() {
      return (
        this.$store.state.service.message || '現在サービスは利用できません。'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.full-screen {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.footer {
  position: fixed;
  bottom: 0;
  margin-bottom: var(--spacing-medium);
}
</style>
